import {MessarioAiPendingDraft} from '@lib/messarioAi/types';

const pendingByKey = new Map<string, MessarioAiPendingDraft>();

export function messarioAiConversationKey(accountId: string, peerId: string | number): string {
  return `${accountId}:${String(peerId)}`;
}

export function getMessarioAiPending(
  accountId: string,
  peerId: string | number
): MessarioAiPendingDraft | undefined {
  return pendingByKey.get(messarioAiConversationKey(accountId, peerId));
}

export function setMessarioAiPending(
  accountId: string,
  peerId: string | number,
  pending: MessarioAiPendingDraft | null
) {
  const key = messarioAiConversationKey(accountId, peerId);
  if(!pending) {
    pendingByKey.delete(key);
    return;
  }

  pendingByKey.set(key, pending);
}

export function clearMessarioAiPending(accountId: string, peerId: string | number) {
  setMessarioAiPending(accountId, peerId, null);
}

/**
 * Clear pending only when it still matches the given training/draft identity.
 * Used after late /complete so Generate B is not wiped by Send A finishing.
 */
export function clearMessarioAiPendingIfMatch(
  accountId: string,
  peerId: string | number,
  match: {training_event_id: number | null, draft_generate_id: number | null}
): boolean {
  const pending = getMessarioAiPending(accountId, peerId);
  if(!pending) {
    return false;
  }

  if(pending.training_event_id !== match.training_event_id) {
    return false;
  }

  if(pending.draft_generate_id !== match.draft_generate_id) {
    return false;
  }

  clearMessarioAiPending(accountId, peerId);
  return true;
}

/** Test helper — clears in-memory pending map. */
export function resetMessarioAiPendingMapForTests() {
  pendingByKey.clear();
}

export function listMessarioAiPendingKeysForTests(): string[] {
  return [...pendingByKey.keys()];
}
